import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '@mdi/react';
import { Box, IconButton, LinearProgress, Stack, SxProps } from '@mui/material';
import { mdiAspectRatio } from '@mdi/js';
import { labelFontSemiBold, vars } from '../../../Theme';

const labelSx: SxProps = {
    ...labelFontSemiBold,
    alignContent: 'center',
    margin: '8px',
};

interface IMinifiedProgressOverlayProps {
    progress?: { current: number; total: number };
    onMaximizeClick?: () => void;
}

export default ({ progress, onMaximizeClick }: IMinifiedProgressOverlayProps) => {
    const { t } = useTranslation('translations', { keyPrefix: 'uploadProgress' });

    const value = useMemo(
        () =>
            progress === undefined
                ? undefined
                : Math.round((progress.current / progress.total) * 100),
        [progress],
    );

    return (
        <Box sx={{ padding: '8px' }}>
            <Stack direction='row'>
                <Box sx={labelSx}>
                    {progress ? t('labelWithCount', { count: progress.total }) : t('labelNoCount')}
                </Box>
                <IconButton onClick={onMaximizeClick}>
                    <Icon path={mdiAspectRatio} size={1} color={vars.black} />
                </IconButton>
            </Stack>
            <LinearProgress variant={progress ? 'determinate' : 'indeterminate'} value={value} />
        </Box>
    );
};
